import React from 'react';
import Header from './Header';
import Footer from './Footer';
import SEO from 'modules/common/components/SEO';

export default function HeaderLayout({ children, className, ...props }: React.ComponentProps<typeof SEO> & { className?: string }) {
  return (
    <>
      <SEO {...props} />
      <Header />
      <main className={className}>{children}</main>

      <Footer />
    </>
  );
}
